/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const DataDecide = ({ color = 'primary', aspectRatio = '1171/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="DataDecide" aspectRatio={aspectRatio} color={color} {...rest} />;

export { DataDecide, DataDecide as default };
